/* global axios */
import ApiClient from './ApiClient';

class CommercialIntegrationsAPI extends ApiClient {
  constructor() {
    super('commercial_integrations', { accountScoped: true });
  }

  updateConfiguration(commercialIntegration) {
    return axios.patch(this.url, {
      commercial_integration: commercialIntegration,
    });
  }

  testConnection() {
    return axios.post(`${this.url}/test`);
  }

  events() {
    return axios.get(`${this.url}/events`);
  }
}

export default new CommercialIntegrationsAPI();
